const HighlightsDisplay = ({ highlights, showEditButton = false, onEditClick }) => {
  // Generate thumbnail for video (placeholder for now)
  const getThumbnail = (link) => {
    if (!link) return "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=400&h=225&fit=crop&crop=center";
    
    // For YouTube links, extract video ID and generate thumbnail URL
    if (link.includes('youtube.com') || link.includes('youtu.be')) {
      try {
        let videoId = '';
        
        if (link.includes('youtube.com/watch?v=')) {
          const url = new URL(link);
          videoId = url.searchParams.get('v');
        } else if (link.includes('youtu.be/')) {
          videoId = link.split('youtu.be/')[1].split('?')[0];
        }
        
        if (videoId) {
          return `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
        }
      } catch (err) {
        console.error("Error parsing YouTube URL:", err);
      }
    }
    
    return "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=400&h=225&fit=crop&crop=center";
  };

  if (!highlights || highlights.length === 0) {
    return (
      <div className="bg-white rounded-[20px] overflow-hidden">
        <div className="p-6 bg-[#F8F9FB] overflow-hidden">
          <div className="text-center py-8">
            <p className="text-gray-500">No highlights available</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-[20px] overflow-hidden">
      {/* Header with Edit Button */}
      {showEditButton && (
        <div className="flex justify-between items-center p-6 pb-0">
          <div></div>
          <button
            onClick={onEditClick}
            className="flex items-center gap-2 bg-[#2283FF] text-[#F5F5F5] px-4 py-2 rounded-lg font-medium"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.334 1.99955C11.5091 1.82445 11.7169 1.68556 11.9457 1.5908C12.1745 1.49604 12.4197 1.44727 12.6673 1.44727C12.9149 1.44727 13.1601 1.49604 13.3889 1.5908C13.6177 1.68556 13.8256 1.82445 14.0007 1.99955C14.1757 2.17465 14.3146 2.38252 14.4094 2.61129C14.5042 2.84006 14.5529 3.08526 14.5529 3.33288C14.5529 3.58051 14.5042 3.8257 14.4094 4.05448C14.3146 4.28325 14.1757 4.49112 14.0007 4.66622L5.00065 13.6662L1.33398 14.6662L2.33398 10.9996L11.334 1.99955Z"
                stroke="#F5F5F5"
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            Edit Highlights
          </button>
        </div>
      )}
      
      {/* Content */}
      <div className="p-6 bg-[#F8F9FB] overflow-hidden">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
          {highlights.map((highlight) => (
            <div
              key={highlight.id}
              className="bg-white rounded-lg overflow-hidden border border-[#D6DBEA] hover:shadow-md transition-shadow duration-200"
            >
              {/* Video Thumbnail */}
              <div className="relative group cursor-pointer">
                <a 
                  href={highlight.url || highlight.link} 
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  <img
                    src={getThumbnail(highlight.url || highlight.link)}
                    alt={highlight.title}
                    className="w-full h-48 object-cover"
                  />
                  {/* Play icon overlay */}
                  <div className="absolute inset-0 bg-black/30 flex items-center justify-center">
                    <div className="w-16 h-16 bg-white/90 rounded-full flex items-center justify-center">
                      <svg
                        className="w-8 h-8 text-black ml-1"
                        fill="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path d="M8 5v14l11-7z" />
                      </svg>
                    </div>
                  </div>
                </a>
              </div>

              {/* Title */}
              <div className="p-4">
                <h3 className="font-medium text-base text-[#222A35] leading-tight">
                  {highlight.title || "Untitled Highlight"}
                </h3>
                {highlight.created_at && (
                  <p className="text-xs text-gray-500 mt-1">
                    {new Date(highlight.created_at).toLocaleDateString()}
                  </p>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HighlightsDisplay; 